import type { ElementType, FC, PropsWithChildren } from 'react'

import { Page } from './styles'

export const AppPage: FC<
  PropsWithChildren<{
    as?: ElementType
  }>
> = ({ children, as, ...rest }) => (
  <Page as={as} {...rest}>
    {children}
  </Page>
)
